// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const azamtvColors: ColorType = { ...colorPalette, primary: '#7936DF', secondary: '#7936DF' }

export const lightTheme = {
  colors: azamtvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: azamtvColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: azamtvColors.dark,
    secondary: azamtvColors.grayText,
    disabled: azamtvColors.dark,
    link: azamtvColors.dark,
    hint: azamtvColors.dark,
    highlight: azamtvColors.primary,
    gray: azamtvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: azamtvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: azamtvColors.dark,
    color: azamtvColors.dark,
    border: azamtvColors.primary,
    scrollbarThumb: azamtvColors.primary,
    programTitle: azamtvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: azamtvColors.dark,
        selected: azamtvColors.dark,
        progress: rgba(azamtvColors.primary, 0.3),
        past: rgba(azamtvColors.primary, 0.3),
        pastSelected: azamtvColors.dark,
        pastHover: azamtvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(azamtvColors.primary, 0.1),
      },
      text: {
        empty: azamtvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: azamtvColors.dark,
    subTitle: azamtvColors.grayText,
    bg: azamtvColors.dark,
    number: azamtvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 220,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
